module.exports = __webpack_public_path__ + "static/icons/icon-more-menu-e64ae4a360c0715310cb1002d25ef597.svg";